export default "__VITE_ASSET__C_xcZ8NZ__"